export const DARK_MAP_THEME_PIXXEL: string =
  'neelduttapixxel/cl6ezkerc001h14nkwct1m0jo';
export const LIGHT_MAP_THEME_PIXXEL: string =
  'neelduttapixxel/cl5tm7r0w000i14pdu92imjpi';
export const SATELLITE_MAP_MAPBOX: string = 'mapbox/satellite-v8';

export const GEOSJON_COLOR_DEFAULT: string = '#3e63dd';

export const DEFAULT_MAP_STATE: {
  center: [number, number];
  zoom: number;
  duration: number;
  minZoom: number;
} = {
  center: [-102.41094535172934, 34.2331797157622],
  zoom: 13,
  duration: 1000,
  minZoom: 2
};
